import { combineReducers } from "redux";

import Auth from "./auth/reducer";
import Layout from "./layout/reducer";
import Organisation from "./organisation/reducer";
import Items from "./items/reducer";
import Parties from "./parties/reducer";
import Vendor from "./vendor/reducer";
import PurchaseOrders from "./purchase-orders/reducer";
import SalesInvoice from "./sales-invoice/reducer";
import SalesReturn from "./sales-return/reducer";
import PurchaseInvoice from "./purchase-invoice/reducer";
import Reports from "./reports/reducer";
import PaymentIn from "./payment-in/reducer";
import PaymentOut from "./payment-out/reducer";
import CashBank from "./cash-bank/reducer";
import Expenses from "./expenses/reducer";

const rootReducer = combineReducers({
  Auth,
  Layout,
  Organisation,
  Items,
  Parties,
  Vendor,
  PurchaseOrders,
  SalesInvoice,
  SalesReturn,
  PurchaseInvoice,
  Reports,
  PaymentIn,
  PaymentOut,
  CashBank,
  Expenses,
});

export default rootReducer;
